import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeIntegrations  {
    _originalTypeClassName = "zERP.BO.BackOfficeIntegrations";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeIntegrations.translate = translateService;
}
this.BackOfficeIntegrationsKey = null;
this._key = this.BackOfficeIntegrationsKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeIntegrationsKey:any;
get BackOfficeIntegrationsKey(): any {
    return this._BackOfficeIntegrationsKey;
  }
set BackOfficeIntegrationsKey(value: any) {
    this._BackOfficeIntegrationsKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeIntegrationsKey == null || $this.BackOfficeIntegrationsKey == 0;
            }


}